module.exports = __webpack_public_path__ + "static/media/arrow-right-outline-color.ea60eb56.svg";